import calculateDerivedProps from './calculateDerivedProps';
import unFlatten from './unFlatten';
/**
 * Creates the order payload to send the api mirroring the ION's structure.
 * @param {object} state - The application's state object (flat).
 * @returns {object} Application object matching the ION's structure to send to API.
 * @memberof module:ionHelpers
 */
const createOrderPayload = (state) => {
    const raw = unFlatten(state);
    const payload = calculateDerivedProps(raw);
    return payload;
};
export default createOrderPayload;
